"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CELL_WIDTH: function() {
        return CELL_WIDTH;
    },
    tableSelectionCellClassNames: function() {
        return tableSelectionCellClassNames;
    },
    useTableSelectionCellStyles_unstable: function() {
        return useTableSelectionCellStyles_unstable;
    }
});
const _react = require("@griffel/react");
const CELL_WIDTH = 44;
const tableSelectionCellClassNames = {
    root: 'fui-TableSelectionCell',
    checkboxIndicator: 'fui-TableSelectionCell__checkboxIndicator',
    radioIndicator: 'fui-TableSelectionCell__radioIndicator'
};
const useTableLayoutStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "f15pt5es",
        a9b677: "fksc0bp"
    }
}, {
    d: [
        ".f15pt5es{display:table-cell;}",
        ".fksc0bp{width:44px;}"
    ]
});
const useFlexLayoutStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "f22iagw",
        Bh6795r: "fqerorx",
        Bnnss6s: "f1neuvcm",
        xawz: "fkjuxzh",
        Bf4jedk: "fvrlu0f",
        B2u0y6b: "f1c71y05",
        Brf1p80: "f4d9j23"
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".fqerorx{flex-grow:1;}",
        ".f1neuvcm{flex-shrink:1;}",
        ".fkjuxzh{flex-basis:0px;}",
        ".fvrlu0f{min-width:44px;}",
        ".f1c71y05{max-width:44px;}",
        ".f4d9j23{justify-content:center;}"
    ]
});
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        fsow6f: "f17mccla",
        Huce71: "fz5stix",
        z8tnut: "f1g0x7ka",
        z189sj: [
            "fhxju0i",
            "f1cnd47f"
        ],
        Byoj8tv: "f1qch9an",
        uwmqm3: [
            "f1cnd47f",
            "fhxju0i"
        ],
        Bn4voq9: "fz36nt7",
        g9k6zt: "f9znhxp",
        Bfpq7zp: "fqrak0z",
        kdpuga: [
            "f1o2ludy",
            "f1kjnpwc"
        ],
        Bw81rd7: [
            "f1kjnpwc",
            "f1o2ludy"
        ],
        B6xbmo0: [
            "fxmnebo",
            "f1witrsb"
        ],
        dm238s: [
            "f1witrsb",
            "fxmnebo"
        ]
    },
    radioIndicator: {
        mc9l5x: "f22iagw",
        Bh6795r: "fqerorx",
        Bt984gj: "f122n59",
        Brf1p80: "f4d9j23"
    },
    subtle: {
        abs64n: "fk73vx1",
        B8a84jv: "f1y7ij6c"
    },
    hidden: {
        Bcdw1i0: "fd7fpy0"
    }
}, {
    d: [
        ".f17mccla{text-align:center;}",
        ".fz5stix{white-space:nowrap;}",
        ".f1g0x7ka{padding-top:0;}",
        ".fhxju0i{padding-right:0;}",
        ".f1cnd47f{padding-left:0;}",
        ".f1qch9an{padding-bottom:0;}",
        ".fz36nt7[data-fui-focus-visible]{outline-width:2px;}",
        ".f9znhxp[data-fui-focus-visible]{outline-style:solid;}",
        ".fqrak0z[data-fui-focus-visible]{outline-color:var(--colorStrokeFocus2);}",
        ".f1o2ludy[data-fui-focus-visible]{border-bottom-right-radius:var(--borderRadiusMedium);}",
        ".f1kjnpwc[data-fui-focus-visible]{border-bottom-left-radius:var(--borderRadiusMedium);}",
        ".fxmnebo[data-fui-focus-visible]{border-top-right-radius:var(--borderRadiusMedium);}",
        ".f1witrsb[data-fui-focus-visible]{border-top-left-radius:var(--borderRadiusMedium);}",
        ".f22iagw{display:flex;}",
        ".fqerorx{flex-grow:1;}",
        ".f122n59{align-items:center;}",
        ".f4d9j23{justify-content:center;}",
        ".fk73vx1{opacity:0;}",
        ".f1y7ij6c[data-fui-focus-within]:focus-within{opacity:1;}",
        ".fd7fpy0{visibility:hidden;}"
    ]
});
const useTableSelectionCellStyles_unstable = (state)=>{
    const styles = useStyles();
    const layoutStyles = {
        table: useTableLayoutStyles(),
        flex: useFlexLayoutStyles()
    };
    state.root.className = (0, _react.mergeClasses)(tableSelectionCellClassNames.root, styles.root, state.noNativeElements ? layoutStyles.flex.root : layoutStyles.table.root, state.subtle && state.checked === false && styles.subtle, state.hidden && styles.hidden, state.root.className);
    if (state.checkboxIndicator) {
        state.checkboxIndicator.className = (0, _react.mergeClasses)(tableSelectionCellClassNames.checkboxIndicator, state.checkboxIndicator.className);
    }
    if (state.radioIndicator) {
        state.radioIndicator.className = (0, _react.mergeClasses)(tableSelectionCellClassNames.radioIndicator, styles.radioIndicator, state.radioIndicator.className);
    }
    return state;
}; //# sourceMappingURL=useTableSelectionCellStyles.styles.js.map
